module.exports = __webpack_public_path__ + "static/img/loadingNine.cb4e160.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/loadingNine.gif
// module id = 6F/6
// module chunks = 1